import type { ChangelogEntry } from "../types";

/** VIB-2929: prosjektbred T&M-faktura tilbød bilag som ikke var godkjent. */
export const TM_BILAGSSTATUS_2026_10: ChangelogEntry = {
  id: "2026-10-24-tm-bilagsstatus",
  date: "2026-10-24",
  title: "T&M-faktura tilbyr bare bokførte bilag",
  summary:
    "Viderefakturering for hele prosjektet tilbød også bilag som ventet på godkjenning eller var avvist. Nå tilbys bare bokførte bilag, som for T&M-mersalg.",
  sections: [
    {
      heading: "Faktura",
      minRole: "user",
      items: [
        {
          title: "Ventende og avviste bilag tilbys ikke lenger",
          kind: "rettet",
          body: "T&M-faktura for hele prosjektet kunne foreslå bilag som ikke var godkjent, også avviste. Nå er det bare bokførte bilag som kan viderefaktureres til kunden.",
        },
      ],
    },
  ],
};
